import React, { useState, useEffect, useRef } from 'react';
import axios from 'axios';
import 'select2/dist/css/select2.min.css';
import '../../styles/principals/booking.css';
import DatePicker, { setDefaultLocale } from "react-datepicker";
import 'react-datepicker/dist/react-datepicker.css';
import $ from 'jquery';
import 'select2';
setDefaultLocale('es');

function Booking() {
  const [selectedServices, setSelectedServices] = useState([]);
  const [selectedServiceNames, setSelectedServiceNames] = useState([]);
  const [selectedPersons, setSelectedPersons] = useState('1');
  const [name, setName] = useState('');
  const [phoneNumber, setPhoneNumber] = useState('');
  const [eMail, setEmail] = useState('');
  const [bookingDate, setBookingDate] = useState('');
  const [dateTime, setDateTime] = useState(new Date().toLocaleString());
  const [specialRequest, setSpecialRequest] = useState('');
  const [showSuccessPopup, setShowSuccessPopup] = useState(false); // Estado para mostrar el mensaje de éxito
  const [showErrorPopup, setShowErrorPopup] = useState(false); // Estado para mostrar el mensaje de error
  const [serviceTypes, setServiceTypes] = useState([]);
  const [services, setServices] = useState([]);
  const [isLoading, setIsLoading] = useState(false);
  const [totalPrice, setTotalPrice] = useState(0); // Estado para almacenar el precio total


  const selectRef = useRef(null);
  const formContainerRef = useRef(null);


  useEffect(() => {
    // Fetch service types and services
    const fetchServicesData = async () => {
      try {
        const serviceTypesResponse = await axios.get(`${process.env.REACT_APP_API_URL}/services/getServicesTypes`);
        const servicesResponse = await axios.get(`${process.env.REACT_APP_API_URL}/services/getServices`);

        setServiceTypes(serviceTypesResponse.data);
        setServices(servicesResponse.data);
      } catch (error) {
        console.error("Error fetching services data:", error);
      }
    };

    fetchServicesData();
  }, []);

  useEffect(() => {
    const selectElement = selectRef.current;
    $(selectElement)
      .select2()
      .on('change', handleServiceSelect);

    return () => {
      $(selectElement).select2('destroy');
    };
  }, []);

  useEffect(() => {
    if (selectedServices.length > 0 && services.length > 0) {
      const selectedNames = selectedServices.map(serviceId => {
        const service = services.find(service => service.id === parseInt(serviceId)); // Asegúrate de que coincidan los tipos
        return service ? service.name : '';
      });
      setSelectedServiceNames(selectedNames);
  
      // Calcular el precio total
      let totalPrice = 0;
      selectedServices.forEach(serviceId => {
        const service = services.find(service => service.id === parseInt(serviceId));
        if (service) {
          totalPrice += service.price;
        }
      });
      totalPrice *= parseInt(selectedPersons); // Multiplicar por el número de personas
      setTotalPrice(totalPrice);
    } else {
      setSelectedServiceNames([]);
      setTotalPrice(0);
    }
  }, [selectedServices, services, selectedPersons]);

  const handleServiceSelect = () => {
    const selectedValues = $(selectRef.current).val() || [];
    setSelectedServices(selectedValues);
  };

  const handlePersonsSelect = (e) => {
    setSelectedPersons(e.target.value);
  };

  const handleSpecialRequestChange = (e) => {
    setSpecialRequest(e.target.value);
  };

  const formatMySQLDate = (date) => {
    const d = new Date(date);
    const year = d.getFullYear();
    const month = (`0${d.getMonth() + 1}`).slice(-2);
    const day = (`0${d.getDate()}`).slice(-2);
    const hours = (`0${d.getHours()}`).slice(-2);
    const minutes = (`0${d.getMinutes()}`).slice(-2);
    const seconds = (`0${d.getSeconds()}`).slice(-2);

    return `${year}-${month}-${day} ${hours}:${minutes}:${seconds}`;
  };

  const handleSubmit = async (e) => {
    e.preventDefault();

    const formattedBookingDate = formatMySQLDate(bookingDate);

    if (name && phoneNumber && eMail && bookingDate) {
      setIsLoading(true);
      try {
        // Guarda la cita en la base de datos
        await axios.post(`${process.env.REACT_APP_API_URL}/booking/save`, {
          selectedServices: selectedServices,
          selectedPersons: selectedPersons,
          name: name,
          phoneNumber: phoneNumber,
          eMail: eMail,
          bookingDate: formattedBookingDate,
          dateTime: dateTime,
          specialRequest: specialRequest
        });

        // Envía correo al cliente
        await axios.post(`${process.env.REACT_APP_API_URL}/email/send`, {
          destinatario: eMail,
          asunto: "Tu solicitud de cita con NOI Donostia está siendo procesada",
          contenido: `
            ¡Gracias por contactar con Noi Donostia!
            
            Pronto nos pondremos en contacto contigo para ultimar los detalles para tu cita de:
            ${selectedServiceNames.join(', ')}.

            El presupuesto es de: ${totalPrice}€. Este se confirmará junto a la cita tras comprobar la petición y sus necesidades especiales.
    
            Saludos cordiales,
            Noi Donostia`
        });

        // Envía correo a NOI Donostia
        await axios.post(`${process.env.REACT_APP_API_URL}/email/send`, {
          destinatario: "noidonostia@gmail.com",
          asunto: "Nueva solicitud de cita",
          contenido: `
            Detalles de la solicitud:
            - Fecha: ${formattedBookingDate}
            - Servicios: ${selectedServiceNames.join(', ')}
            - Cantidad de personas: ${selectedPersons}
            - Nombre: ${name}
            - Teléfono: ${phoneNumber}
            - eMail: ${eMail}
            - Petición especial: ${specialRequest}
            - Presupuesto: ${totalPrice}€          

            Administracion Noi`
        });

        // Resetea el formulario
        setSelectedServices([]);
        setSelectedPersons('1');
        setName('');
        setPhoneNumber('');
        setEmail('');
        setBookingDate('');
        setDateTime('');
        setSpecialRequest('');
        setIsLoading(false);
        setShowSuccessPopup(true);

        setTimeout(() => {
          setShowSuccessPopup(false);
        }, 7000);

      } catch (error) {
        console.error('Error en el proceso de cita:', error);
        setIsLoading(false);
        setShowErrorPopup(true);
        setTimeout(() => {
          setShowErrorPopup(false);
        }, 7000);
      }
    } else {
      console.error('Uno o más campos del formulario están vacíos');
    }
  };

  const today = new Date();
  const minDate = new Date(today.getFullYear(), today.getMonth(), today.getDate() + 1);
  const minTime = new Date();
  minTime.setHours(9, 0);
  const maxTime = new Date();
  maxTime.setHours(20, 0);

  useEffect(() => {
    if (isLoading) {
      window.scrollTo({ top: 0, behavior: 'smooth' });
    }
  }, [isLoading]);

  useEffect(() => {
    window.scrollTo({ top: 0, behavior: 'smooth' });
  }, []);

  return (
    <div className="booking-container" ref={formContainerRef}>
      <h2>Solicitar un servicio</h2>
      {isLoading && <div className="loading"><img src="/loading.gif" alt="Loading..." /></div>}
      <form onSubmit={handleSubmit}>
        <div className="booking-select">
          <label>Selecciona uno o más servicios:</label>
          <select className="booking-multiselect" multiple value={selectedServices} onChange={handleServiceSelect} ref={selectRef}>
            {serviceTypes.map(type => (
              <optgroup key={type.id} label={type.name}>
                {services.filter(service => service.type_id === type.id).map(service => (
                  <option key={service.id} value={service.id}>{service.name} - {service.price}€</option>
                ))}
              </optgroup>
            ))}
          </select>
        </div>
        <div>
          <label>Selecciona cantidad de personas:</label>
          <select value={selectedPersons} onChange={handlePersonsSelect}>
            <option value="1">1 persona</option>
            <option value="2">2 personas</option>
            <option value="3">3 personas</option>
            <option value="4">4 personas</option>
            <option value="5">5 personas</option>
          </select>
        </div>

        {showSuccessPopup && (
          <div className="success-message">Tu solicitud de cita se ha enviado correctamente. En breves contactaremos contigo para concretar los últimos detalles. </div>
        )}
        {showErrorPopup && (
          <div className="error-message">Error inesperado. Por favor, revisa el formulario o ponte en contacto con nosotros vía email o teléfono. </div>
        )}

        {selectedServices.length > 0 && (
          <div>
            <h3>Cantidad de personas: {selectedPersons}</h3>
            <div>
              <label>Nombre completo:</label>
              <input type="text" value={name} onChange={(e) => setName(e.target.value)} required />
            </div>
            <div>
              <label>Número de teléfono:</label>
              <input type="text" value={phoneNumber} onChange={(e) => setPhoneNumber(e.target.value)} required />
            </div>
            <div>
              <label>Correo electrónico:</label>
              <input type="email" value={eMail} onChange={(e) => setEmail(e.target.value)} required />
            </div>
            <div>
              <label>Fecha y hora:</label>
              <DatePicker
                selected={bookingDate}
                onChange={(date) => setBookingDate(date)}
                showTimeSelect
                timeFormat="HH:mm"
                timeIntervals={15}
                minDate={minDate} // Establece la fecha mínima como el próximo día
                minTime={minTime}
                maxTime={maxTime}
                dateFormat="dd-MM-yyyy HH:mm"
                timeCaption="Hora"
                required
              />
            </div>
            <div>
              <label>Comentario o necesidad especial:</label>
            </div>
            <div>
              <textarea value={specialRequest} onChange={handleSpecialRequestChange} />
            </div>
            <div className="total-price">
              <p>Presupuesto estimado para {selectedPersons} persona/s: {totalPrice}€ </p>       
            </div>
            <div className="booking-button">
              <button className="home-button" type="submit">Enviar solicitud de cita</button>
            </div>
            <div className="center-text">
              <p>AVISO: Esto no es una confirmación de cita, sino una solicitud que será concretada y confirmada por teléfono o vía email.</p>
              <p>AVISO: El precio final se obtendrá con la confirmación de cita tras comprobar la petición y sus necesidades especiales</p>
            </div>
          </div>
        )}
      </form>
    </div>
  );
}

export default Booking;
